import { render, staticRenderFns } from "./alldmoList.vue?vue&type=template&id=b6b0bf70&scoped=true"
import script from "./alldmoList.vue?vue&type=script&lang=js"
export * from "./alldmoList.vue?vue&type=script&lang=js"
import style0 from "./alldmoList.vue?vue&type=style&index=0&id=b6b0bf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b0bf70",
  null
  
)

export default component.exports